import { getTranslation } from '../providers/TranslationProvider';

const handleCreatedByText = (display) => getTranslation({
  translationKey: 'lists.by',
  translationValues: { user: `${display}` },
  fallback: `By ${display}`,
});

export default handleCreatedByText;
